import { IDisplayUser } from "../../async/AsyncCalls";

export enum USER_ACTION_TYPE {    
    USER_PROFILE_UPDATE = 'user/profile-update',
    TOKEN_UPDATE = 'user/token-update',
};

export type IUserState = {
    token: string,
    profile: IDisplayUser
};

function getInitialUserSetting(): IUserState {
    return {
        token: '',
        profile: {            
            name: '',
            email: '',
            vendor: 'google',
            image: '',
            role: 'new', 
        }        
    };
}

export function userReducer(state = getInitialUserSetting(), action: {type: USER_ACTION_TYPE, payload: any}) {
    switch (action.type) {
        case USER_ACTION_TYPE.USER_PROFILE_UPDATE:
            return {...state, profile: action.payload};
        case USER_ACTION_TYPE.TOKEN_UPDATE:
            return {...state, token: action.payload};
        default:
            return state;
    }
}